<template>
  <div>
    <div v-if="loading" style="text-align: center">
      <br>
      <v-progress-circular
        :size="80"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <br>
      <br>
      Logging In...
    </div>
    <v-form v-if="!loading"
            ref="form"
    >
      <v-text-field
        v-model="email"
        label="E-mail"
        placeholder=" "
        required
        name="email"
        ref="email"
      ></v-text-field>
      <v-text-field
        v-model="password"
        type="password"
        label="Password"
        required
        name="password"
        placeholder=" "
        v-on:keyup.enter="login"
        ref="password"
      ></v-text-field>
      <div class="text-xs-center" style="text-align: center">
        <v-btn color="info" class="text-xs-center" @click="login">Login</v-btn><br>
      </div>
    </v-form>
  </div>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import gql from 'graphql-tag';
import graphql from '@/helpers/graphql';

const Component = Vue.extend({
  name: 'Login',
  data() {
    return {
      loading: false,
      email: '',
      password: '',
    };
  },
  methods: {
    async login() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const query = gql`
            mutation($input: UserLoginInput!) {
              userLogin(input: $input) {
                sessionId
              }
            }
        `;

        const variables = {
          input: {
            email: this.email,
            password: this.password,
          },
        };

        const response = await graphql(query, variables);

        if (response && response.userLogin) {
          Vue.$cookies.set(
            'session_id',
            response.userLogin.sessionId,
            null,
            '/',
            window.location.href.includes('localhost') ? 'localhost' : '.degreenexus.com',
          );

          this.$router.go();
        } else {
          this.loading = false;
        }
      }
    },
  },
});

export default Component;
</script>
